import { Me } from 'api/types'

/** Where to send a user right after sign-in/OTP/invite-acceptance succeeds. */
export const postAuthPath = (user: Me, from?: string | null) => {
  if (from && from !== '/login') return from
  if (user.memberships.length > 1) return '/select-project'
  if (user.memberships.length === 1) return `/projects/${user.memberships[0].projectId}`
  return '/'
}
